import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { Config } from 'src/app/app-constant';
import { FormBuilder } from '@angular/forms';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
@Component({
  selector: 'app-ess-dashboard-popups',
  templateUrl: './ess-dashboard-popups.component.html',
  styleUrls: ['./ess-dashboard-popups.component.scss'],
})
export class EssDashboardPopupsComponent implements OnInit {
  isToggleChecked: any = false;
  popupName: any;
  loggedInUserCompanyID: any;
  selectedYear: any;
  selectedSurveyIDForDashboardGlobal: any;
  listOfEmployees: any = []
  scoresOfSurveysList: any = [];
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private encryptionService: EncryptionService, public router: Router, private activatedroute: ActivatedRoute,
    public dialog: MatDialog, public sharedService: SharedService,
    private loader: LoaderService,
    private httpService: HttpService, private config: Config, private fb: FormBuilder,
    private datePipe: DatePipe) { }

  ngOnInit() {
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.popupName = this.data?.popupName;
    this.selectedYear = this.data?.selectedYear;
    this.selectedSurveyIDForDashboardGlobal = this.data?.selectedSurveyIDForDashboardGlobal;
    if (this.popupName == 'NoOfSurveysCreated') {
      this.getYearlyCounter();
    }
    if (this.popupName == 'scoresOfSurveys') {
      this.getNoOfSurveysDetails();
    }
    
    if (this.popupName == 'noOfEmployee') {
      this.getSurveyCounter();
    }
  }

  getNoOfSurveysDetails() {
    var type = 'Incomplete';
    if (this.isToggleChecked) { type = 'Complete' }
    const year = this.selectedYear?.split('-')
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "essId": null,
      "fromYear": year[0],
      "toYear": year[1],
      "type": type
    }
    this.httpService.callPostService(this.config.getNoOfSurveysDetails, request).subscribe((data: any) => {
      this.scoresOfSurveysList = data?.data;
    })
  }

  noOfSurveysCreated: any = 0;
  noOfEmployees: any = 0;
  minScore: any = 0;
  maxScore: any = 0;
  avgScore: any = 0;
  noOfSurveysCreatedYearly: any = 0;
  noOfEmployeesYearly: any = 0;
  minScoreYearly: any = 0;
  maxScoreYearly: any = 0;
  avgScoreYearly: any = 0;
  getSurveyCounter() {
    
    var type = 'Incomplete';
    if (this.isToggleChecked) { type = 'Complete' }
    const year = this.selectedYear?.split('-');
    if (this.selectedSurveyIDForDashboardGlobal != null) {
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "essId": this.selectedSurveyIDForDashboardGlobal,
        "fromYear": year[0],
        "toYear": year[1],
        "type": type
      }
      this.httpService.callPostService(this.config.getSurveyCounter, request).subscribe((data: any) => {
        this.listOfEmployees = data?.data?.employees ? data?.data?.employees : [];
      })
    }
  }
  getYearlyCounter() {
    var type = 'Incomplete';
    if (this.isToggleChecked) { type = 'Complete' }
    const year = this.selectedYear?.split('-')
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "essId": null,
      "fromYear": year[0],
      "toYear": year[1],
      "type": type
    }
    this.httpService.callPostService(this.config.getYearlyCounter, request).subscribe((data: any) => {
      this.noOfSurveysCreatedYearly = data?.data?.noOfSurveysCreated ? data?.data?.noOfSurveysCreated : 0;
      this.noOfEmployeesYearly = data?.data?.noOfEmployees ? data?.data?.noOfEmployees : 0;
      this.minScoreYearly = data?.data?.minScore ? data?.data?.minScore : 0;
      this.maxScoreYearly = data?.data?.maxScore ? data?.data?.maxScore : 0;
      this.avgScoreYearly = data?.data?.avgScore ? data?.data?.avgScore : 0;
    })
  }
  onChangeSwitch(event: any) {
    this.isToggleChecked = event?.checked;
    if (this.popupName == 'NoOfSurveysCreated') {
      this.getYearlyCounter();
    }
    if (this.popupName == 'scoresOfSurveys') {
      this.getNoOfSurveysDetails();
    }
    if (this.popupName == 'noOfEmployee') {
      this.getSurveyCounter();
    }
  }
  isDownload:boolean=true;
  onClickDownloadScoresOfSurveys(id:any) {
      this.isDownload=false;
      const tableId = id
      const table = document.getElementById(tableId) as HTMLTableElement;
      const currentDate = new Date();
      const formattedDate = currentDate.toLocaleDateString('en-GB').split('/').join('-');
      if (!table) {
        alert('Table not found!');
        return;
      }
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(table);
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      XLSX.writeFile(wb, `${tableId}_${formattedDate}.xlsx`);
      this.isDownload=true;
      this.loader.dismissLoader()
  }
  onClickDownloadnoOfEmployee() {
    const flattenedData: any[] = [];
    this.listOfEmployees.forEach((ele: any) => {
      flattenedData.push({
        "Employee ID": ele.employeeId,
        "Employee Name": ele.firstName + ' ' + ele.lastName,
      });
    });
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(flattenedData);
    const workbook: XLSX.WorkBook = {
      Sheets: { 'data': worksheet },
      SheetNames: ['data'],
    };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
    const fileName = 'Employees Variable Pay .xlsx';
    saveAs(data, fileName);
  }
}
